import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect, useRef } from 'react';
import { STATUS_COMPLETED } from 'utils/asset/getUserAssetStatus';
export var DEFAULT_AUTO_COMPLETION_DELAY = 5 * 1000; // mark as done after 5 seconds

export function useAutoCompletion(_ref) {
  var autoCompleteEnabled = _ref.autoCompleteEnabled,
    userContentStatus = _ref.userContentStatus,
    onComplete = _ref.onComplete,
    onError = _ref.onError,
    autoCompletionDelay = _ref.autoCompletionDelay;
  var wasAssetCompletedRef = useRef(userContentStatus === STATUS_COMPLETED);
  var _useState = useState(userContentStatus),
    _useState2 = _slicedToArray(_useState, 2),
    status = _useState2[0],
    setStatus = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    failedToLoad = _useState4[0],
    setFailedToLoad = _useState4[1];
  useEffect(function () {
    if (autoCompleteEnabled && status === STATUS_COMPLETED && !wasAssetCompletedRef.current && userContentStatus !== STATUS_COMPLETED && !failedToLoad && typeof onComplete === 'function') {
      wasAssetCompletedRef.current = true;
      onComplete();
    }
  }, [autoCompleteEnabled, userContentStatus, status, failedToLoad, onComplete]);
  useEffect(function () {
    var timer;
    if (autoCompletionDelay) {
      timer = setTimeout(function () {
        setStatus(STATUS_COMPLETED);
      }, autoCompletionDelay);
    }
    return function () {
      return clearTimeout(timer);
    };
  }, [autoCompletionDelay]);
  var markAsFailedToLoad = function markAsFailedToLoad() {
    setFailedToLoad(true);
    if (typeof onError === 'function') {
      onError.apply(void 0, arguments);
    }
  };
  var markAsCompleted = function markAsCompleted() {
    return setStatus(STATUS_COMPLETED);
  };
  return {
    status: status,
    completed: status === STATUS_COMPLETED,
    markAsCompleted: markAsCompleted,
    markAsFailedToLoad: markAsFailedToLoad
  };
}
export default function AutoCompleteWrapper(_ref2) {
  var autoCompleteEnabled = _ref2.autoCompleteEnabled,
    userContentStatus = _ref2.userContentStatus,
    onComplete = _ref2.onComplete,
    _ref2$autoCompletionD = _ref2.autoCompletionDelay,
    autoCompletionDelay = _ref2$autoCompletionD === void 0 ? DEFAULT_AUTO_COMPLETION_DELAY : _ref2$autoCompletionD,
    children = _ref2.children;
  useAutoCompletion({
    autoCompleteEnabled: autoCompleteEnabled,
    userContentStatus: userContentStatus,
    autoCompletionDelay: autoCompletionDelay,
    onComplete: onComplete
  });
  return children;
}